export default {"src":"/_next/static/media/0xa7a0a9fda65cd786b3dc718616cee25afb110544.417421f9.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};